import React from "react";

export default function NewYearFrame10({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-10ne1{fill:#003f2e}.cls-10ne3{fill:#fce9d2}.cls-10ne4{fill:#b25340}.cls-10ne5{fill:#9e493b}"
            }
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_14"
          data-name="\u0421\u043B\u043E\u0439 14"
        >
          <path d="M687.94 1453.51h576v178.94h-576z" className="cls-10ne1" />
          <path
            d="M771.85 834 611.67 351.85a71.4 71.4 0 0 0-12.12-22.2 78.53 78.53 0 0 0-13.34-13A94.6 94.6 0 0 0 560 302.48a117.18 117.18 0 0 0-31.71-6.48 137 137 0 0 0-39.22 3.19q-6.92 1.56-13.83 3.85c-32.46 10.79-57.87 31.63-71.83 55.93a88.8 88.8 0 0 0-11 30.4 72.13 72.13 0 0 0 2.68 34.37l2.46 7.42a24.09 24.09 0 0 0 6.15 9.71 30.41 30.41 0 0 0 11.05 6.74 38.84 38.84 0 0 0 6.95 1.74 45.67 45.67 0 0 0 21.3-1.87c17.07-5.67 28.28-19.71 27.89-33.41a23.84 23.84 0 0 0-1.2-6.8l-4.52-13.62c-5.39-16.2 7.7-35 29-41a41.59 41.59 0 0 1 30.07 2.66c6 3.17 10.74 7.93 13 13.8.13.34.26.68.37 1l162 487.66c2.11 6.48 10.4 9.64 18.67 6.9l42.49-14.12c8.29-2.71 13.23-10.15 11.08-16.55Z"
            style={{
              fill: "#f2673f",
            }}
          />
          <path
            d="m754.23 780.93-6.05-18.23q-8.16 5.2-16.39 10.57-25.54 16.73-49.17 33.23l6.11 18.38q27-18.76 56-37.73ZM732.67 716l-6-18.16q-12.23 7.71-24.6 15.79-21.19 13.85-41.09 27.61l6.11 18.4q23.26-16 47.88-32.13 8.86-5.81 17.7-11.51ZM711.11 651.13l-6-18.07q-16.27 10.14-32.84 21-16.9 11-33 22l6.12 18.42q19.41-13.25 39.78-26.58 13.04-8.54 25.94-16.77ZM689.56 586.28l-6-18q-20.33 12.53-41.1 26.08-12.68 8.26-24.86 16.52l6.12 18.42q15.53-10.5 31.64-21.06 17.24-11.24 34.2-21.96ZM668 521.45l-5.93-17.85q-24.35 14.83-49.37 31.15-8.47 5.54-16.73 11l6.13 18.43q11.58-7.79 23.51-15.59Q647 534.62 668 521.45ZM646.5 456.68 640.61 439q-28.33 17-57.61 36.11-4.32 2.82-8.58 5.64l6.11 18.39c5.07-3.38 10.21-6.76 15.37-10.15q25.56-16.75 50.6-32.31ZM625 392l-5.85-17.6q-32.31 19.25-65.94 41.14a3.62 3.62 0 0 0-.41.27l6.09 18.35c2.4-1.59 4.8-3.17 7.22-4.75Q595.92 409.83 625 392ZM469.68 407.27l-4-12.13q-32.83 23.22-62 45.81a30.41 30.41 0 0 0 11.05 6.74 38.84 38.84 0 0 0 6.95 1.74q23.74-17.51 49.2-35.36a23.84 23.84 0 0 0-1.2-6.8ZM599.55 329.65a78.53 78.53 0 0 0-13.34-13q-30.39 18.19-62 38.72c6 3.17 10.74 7.93 13 13.8q31.62-20.7 62.34-39.52ZM528.28 296.05a137 137 0 0 0-39.22 3.19 1840.778 1840.778 0 0 0-85.66 59.78 88.8 88.8 0 0 0-11 30.4c35.25-26 73.28-52.55 114.19-79.34q10.89-7.08 21.69-14.03Z"
            className="cls-10ne3"
          />
          <path
            d="M1267.62 882.62A43.4 43.4 0 0 0 1310 927l145.66 3.48A43.41 43.41 0 0 1 1498 975l-5.68 237.89a43.4 43.4 0 0 1-44.43 42.36l-145.66-3.48a43.4 43.4 0 0 0-44.42 42.35 43.39 43.39 0 0 0 42.35 44.43l215.43 5.15a43.42 43.42 0 0 0 44.43-42.36l9.82-411.46a43.4 43.4 0 0 0-42.35-44.42l-215.43-5.15a43.4 43.4 0 0 0-44.44 42.31Z"
            className="cls-10ne1"
          />
          <path
            d="m1209.314 419.547 78.227 26.175-136.104 406.773-78.228-26.174z"
            className="cls-10ne4"
          />
          <path
            d="m1287.55 445.72-6.06 18.12-56.85-19.02-130.05 388.65-21.38-7.15 136.11-406.77 78.23 26.17z"
            className="cls-10ne5"
          />
          <path
            d="m1348.719 332.758 78.227 26.174-136.105 406.774-78.227-26.175z"
            className="cls-10ne4"
          />
          <path
            d="m1426.95 358.93-6.06 18.12-56.85-19.02-130.05 388.65-21.37-7.15 136.1-406.77 78.23 26.17z"
            className="cls-10ne5"
          />
          <path
            d="m1413.81 629.37-19.72 206.75-1.7 17.77-1.69 17.73-5.89 61.79-16.11 168.91-1.48 15.54-22.79 239-2.8 29.36-6.81 71.47-1.09 11.39-8.06 84.51-694.9 1-5.94-59.29-1.24-12.33q-1.38-13.89-2.78-27.78-1.56-15.54-3.11-31.07l-22.62-225.73q-1.51-15.06-3-30.13l-23.36-232.95q-2.75-27.48-5.5-55-1.46-14.48-2.9-29-.81-8-1.61-16.09l-20.64-205.85Z"
            style={{
              fill: "#f04f26",
            }}
          />
          <path
            d="M1403.11 741.6a84.55 84.55 0 0 0 23.24-36.76c11.62-38-9.2-70.45-12.54-75.47H538.07c-2.89 3.26-24.85 28.81-18.69 64.15 5 28.78 25.28 44.62 29.94 48.08Z"
            className="cls-10ne1"
          />
          <rect
            width={628.34}
            height={628.34}
            x={661.78}
            y={825.18}
            rx={146.59}
            style={{
              fill: "#eafefe",
            }}
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
